import { getColorByDeviceKey } from './RaceColors.js';
import EventBus from "../../common/EventBus.js";

class RaceDataService {

  constructor() {
    this.chartData = { datasets: [], labels: [] };
    this.currentData = [];
    this.laps = [];
    this.resetCounter = new Map();
    this.minMaxValuesStore = new Map();
    this.chartDataTmp = {}
    this.deviceCoordsHist = {}
    this.intervalFetch = undefined
    this.iLoop = 0
    this.NB_DATA = 360;
    this.NB_DATA_POS = 60;
    this.selectedCombinations = [];
    this.raceDevices = [];
    this.hiddenDatasets = [];
    this.lastDispatchTimestamp = Date.now();
    this.lastChartTimestamp = Date.now();

    console.log("RaceDataService");

    this.handleResetDeviceStorage = this.handleResetDeviceStorage.bind(this);

    EventBus.on('handleResetDeviceStorage', this.handleResetDeviceStorage.bind(this));
    EventBus.on('mqttRaceRtData', this.handleMqttRtData.bind(this));
    EventBus.on('mqttRaceLaps', this.handleMqttLaps.bind(this));

  }

  destroy() {
    EventBus.remove('handleResetDeviceStorage', this.handleResetDeviceStorage);
    EventBus.remove('mqttRaceRtData', this.handleMqttRtData.bind(this));
    EventBus.remove('mqttRaceLaps', this.handleMqttLaps.bind(this));
  }


  on(eventName, callback) {
    // console.log("RaceDataService / on");
    EventBus.on(eventName, callback);
  }

  removeListener(eventName, callback) {
    console.log("RaceDataService / removeListener");
    EventBus.remove(eventName, callback);
  }


  handleResetDeviceStorage(deviceKey) {

    console.log("RaceDataService / handleResetDeviceStorage", deviceKey);

    this.resetCounter.set(deviceKey, 1);

    console.log("RaceDataSvc / handleResetDeviceStorage / deviceKey", deviceKey, "resetMinMaxRequests", this.resetCounter);

    // Reset the position data for the specific deviceKey
    if (this.deviceCoordsHist[deviceKey]) {
      this.deviceCoordsHist[deviceKey] = {
        latitude: [],
        longitude: []
      };
    }
  };

  removeDevice(key) {
    const index = this.currentData.findIndex(data => data.mac_custom.toLowerCase() === key.toLowerCase());
    if (index !== -1) { // Make sure the item exists before trying to remove it
      this.currentData.splice(index, 1);
    } else {
      console.log("RaceDataService / removeDevice / index => not found");
    }

    delete this.deviceCoordsHist[key];

    this.updateData();
  }

  updateData() {

    EventBus.dispatch('dataUpdated', {
      chartData: this.chartData,
      deviceCoordsHist: this.deviceCoordsHist,
      currentData: this.currentData,
      minMaxValues: this.minMaxValuesStore,
      iLoop: this.iLoop
    });
  }

  processData(deviceData) {

    const key = deviceData.mac_custom.toLowerCase();

    // Before processing or fetching, remove devices not in selectedCombinations from updatedDeviceCoords
    const selectedKeys = this.selectedCombinations.map(device => device.mac_custom.toLowerCase());
    Object.keys(this.deviceCoordsHist).forEach(key => {
      if (!selectedKeys.includes(key)) {
        delete this.deviceCoordsHist[key];
      }
    });

    // console.log("RaceDataSvc / processData / key", key);

    let minMaxValues = this.minMaxValuesStore[key]
    // let minMaxValues = minMaxValuesRef.current[key];

    if (!minMaxValues) {
      minMaxValues = {};
      // minMaxValuesRef.current[key] = minMaxValues;
      this.minMaxValuesStore[key] = minMaxValues;
    }

    Object.keys(deviceData).forEach(param => {
      if (typeof deviceData[param] === "number") {
        const prevMinMax = minMaxValues[param] || {
          min: deviceData[param],
          max: deviceData[param],
          dir: 0
        };

        let direction = 0;
        if (deviceData[param] > prevMinMax.max) {
          direction = 1;
        } else if (deviceData[param] < prevMinMax.min) {
          direction = -1;
        }

        const resetCounter = this.resetCounter.get(key) || 0;
        if (resetCounter > 0) {
          minMaxValues[param] = {
            min: deviceData[param],
            max: deviceData[param],
            dir: 0,
          };
        }
        else {
          minMaxValues[param] = {
            min: Math.min(prevMinMax.min, deviceData[param]),
            max: Math.max(prevMinMax.max, deviceData[param]),
            dir: direction,
          };
        }
      }
    });

    const resetCounter = this.resetCounter.get(key) || 0;
    if (resetCounter > 0) {
      this.resetCounter.set(key, 0);
    }

    // console.log("RaceDataSvc / processData / minMaxValuesStore", this.minMaxValuesStore);

    // Existing device data or an empty object if not present
    const updatedDeviceCoord = this.deviceCoordsHist[key]
      ? { ...this.deviceCoordsHist[key] }
      : {
        latitude: [],
        longitude: [],
      };

    // Then you can safely push to the arrays as before:
    if (
      ((deviceData.latitude !== 0 && deviceData.longitude !== 0)
        && (!updatedDeviceCoord.latitude.length || updatedDeviceCoord.latitude[updatedDeviceCoord.latitude.length - 1] !== deviceData.latitude)
        && (!updatedDeviceCoord.longitude.length || updatedDeviceCoord.longitude[updatedDeviceCoord.longitude.length - 1] !== deviceData.longitude)
      )) {
      updatedDeviceCoord.latitude.push(deviceData.latitude);
      updatedDeviceCoord.longitude.push(deviceData.longitude);
      updatedDeviceCoord.latitude = updatedDeviceCoord.latitude.slice(-this.NB_DATA_POS);
      updatedDeviceCoord.longitude = updatedDeviceCoord.longitude.slice(-this.NB_DATA_POS);

      // Here, rather than updating the existing object directly, we spread the previous state and then overwrite the specific key with the new data. This ensures a new object reference.
      this.deviceCoordsHist = {
        ...this.deviceCoordsHist,
        [key]: updatedDeviceCoord
      };
    } else {
      // console.log("RaceDataSvc / this.updatedDeviceCoords not updated");
    }

    // Set laps datas
    deviceData.laps = this.laps[key] || { lapTimes: [], lapCount: 0 }

    // Find the index of the existing data for the device
    const index = this.currentData.findIndex(data => data.mac_custom.toLowerCase() === key.toLowerCase());

    if (index > -1) {
      // If the device data already exists, update it
      // this.currentData[index] = deviceData;
      this.currentData = [
        ...this.currentData.slice(0, index),
        deviceData,
        ...this.currentData.slice(index + 1)
      ];
    } else {
      // If the device data does not exist, add it
      // this.currentData.push(deviceData);
      this.currentData = [...this.currentData, deviceData];
    }

    // console.log("RaceDataService / processData / currentData", this.currentData);
    // console.log("RaceDataSvc / this.updatedDeviceCoords", this.updatedDeviceCoords["08:3a:8d:0b:ce:cc"].latitude);

  }

  processChartData() {


    const newDatasets = this.selectedCombinations.map(device => {
      const key = device.mac_custom.toLowerCase();
      const deviceDetails = this.raceDevices.find(raceDevice => raceDevice.mac_custom.toLowerCase() === key);
      const bleName = deviceDetails ? deviceDetails.ble_name : `Device ${device.mac_custom}`;
      const color = getColorByDeviceKey(key);

      if (!this.chartDataTmp.hasOwnProperty(key)) {
        this.chartDataTmp[key] = {
          voltage: [],
          speed: [],
          current: [],
          acceleration: [],
          latitude: [],
          longitude: [],
          timestamps: [],
        };
      }

      const deviceData = this.currentData.find(data => data.mac_custom.toLowerCase() === key);

      if (!deviceData) {
        return [];
      }

      ////
      const updatedChartDatas = this.chartDataTmp[key];

      updatedChartDatas.voltage.push(deviceData.voltage);
      updatedChartDatas.speed.push(deviceData.speed);
      updatedChartDatas.current.push(deviceData.current);
      updatedChartDatas.acceleration.push(deviceData.acceleration);

      //          const formattedTimestamp = new Date().toLocaleTimeString();
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

      const formattedTimestamp = `${hours}:${minutes}:${seconds}.${milliseconds}`;

      updatedChartDatas.timestamps.push(formattedTimestamp);
      // updatedDeviceData.timestamps.push(new Date().getTime())

      updatedChartDatas.voltage = updatedChartDatas.voltage.slice(-this.NB_DATA);
      updatedChartDatas.speed = updatedChartDatas.speed.slice(-this.NB_DATA);
      updatedChartDatas.current = updatedChartDatas.current.slice(-this.NB_DATA);
      updatedChartDatas.acceleration = updatedChartDatas.acceleration.slice(-this.NB_DATA);
      updatedChartDatas.timestamps = updatedChartDatas.timestamps.slice(-this.NB_DATA);

      this.chartDataTmp[key] = updatedChartDatas;


      // eject dataset if device doesn't have RT data
      if ((this.chartDataTmp[key] == undefined))
        return [];

      return [
        {
          data: this.chartDataTmp[key]?.voltage || [],
          label: `${bleName} - Voltage`,
          borderColor: color,
          backgroundColor: color,
          borderDash: [5, 5],
          hidden: this.hiddenDatasets.includes(`${bleName} - Voltage`),
          unit: "V",
        },
        {
          data: this.chartDataTmp[key]?.speed || [],
          label: `${bleName} - Speed`,
          borderColor: color,
          backgroundColor: color,
          borderDash: [1, 1],
          hidden: this.hiddenDatasets.includes(`${bleName} - Speed`),
          unit: "Km/h",
        },
        {
          data: this.chartDataTmp[key]?.current || [],
          label: `${bleName} - Current`,
          borderColor: color,
          backgroundColor: color,
          borderDash: [2, 2],
          hidden: this.hiddenDatasets.includes(`${bleName} - Current`),
          unit: "A",
          yAxisID: 'y2',
        },
      ];
    }).flat();

    const keyFirstDevice = this.selectedCombinations[0]?.mac_custom.toLowerCase()

    this.chartData = {
      datasets: newDatasets,
      labels: this.chartDataTmp[keyFirstDevice]?.timestamps || [],
    };

  }

  handleMqttRtData(data) {
    // console.log('RaceDataService / handleMqttRtData / data:', data.toString());

    this.processData(data.parsedMessage);

    const now = Date.now();

    if (Date.now() - this.lastChartTimestamp >= 300) {
      this.lastChartTimestamp = now;
      if (this.hiddenDatasets != undefined)
        this.processChartData();
    }

    if (Date.now() - this.lastDispatchTimestamp >= 100) {
      this.lastDispatchTimestamp = now;

      // console.log('RaceDataService / handleMqttRtData / dataUpdated')

      this.updateData();
    } else {
      // console.log('RaceDataService / handleMqttRtData / too soon');
    }

  }

  handleMqttLaps(data) {
    console.log('RaceDataService / handleMqttLaps / data :', data);

    const splits = data.topic.split('/')
    const racerTeam = splits[1]
    const racerMacCustom = splits[3]

    this.laps[racerMacCustom.toLowerCase()] = {
      lapTimes: data.parsedMessage.lapTimes,
      lapFinishedCount: data.parsedMessage.lapFinishedCount,
      lapCurrent: data.parsedMessage.lapCurrent,
      nbLapsOfRace: data.parsedMessage.nbLapsOfRace,
      raceStartTimestamp: data.parsedMessage.raceStartTimestamp,
      raceStopTimestamp: data.parsedMessage.raceStopTimestamp,
    }

    this.updateData();
  }

  setData(selectedCombinations, raceDevices, hiddenDatasets) {

    this.selectedCombinations = selectedCombinations;
    this.raceDevices = raceDevices;
    this.hiddenDatasets = hiddenDatasets;

  }
}

const raceDataService = new RaceDataService();
export default raceDataService;
